export default __webpack_public_path__ + "static/contactUs-a503413a257489dfc5676762f49a7f82.svg";